import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  FDBox, FDIcon, FDPaper, FDStack, FDTitleText,
} from '@facet-wealth/design';

const AccountMappingMetaFormLayout = () => {
  const {
    resource,
  } = useMetaLayoutContext();

  const onChange = (attr) => async (value) => {
    resource.attr(attr, value);
  };

  const hasNoMapping = resource.attr('mappedAccount') === '-1';
  return (
    <FDPaper
      appearance={'outlined'}
      padding={2}
    >
      <FDStack justifyContent="space-between" alignItems={'center'}>
        <FDBox paddingX={6} minWidth="50%">
          <FDStack direction="row" spacing={2} alignItems="center">
            {hasNoMapping && (
              <FDIcon
                color="attention"
                icon="warning"
                size="md"
              />
            )}
            {!hasNoMapping && (
              <FDIcon
                color="success"
                icon="checkCircleIcon"
                size="md"
              />
            )}
            <FDTitleText value={resource.attr('virtualAccountDisplayName')} />
          </FDStack>
        </FDBox>
        <FDBox paddingX={6} minWidth="50%">
          <MetaControlField
            attr={'mappedAccount'}
            resource={resource}
            onChange={onChange('mappedAccount')}
            fullWidth
          />
        </FDBox>
      </FDStack>
    </FDPaper>
  );
};

export default AccountMappingMetaFormLayout;
